export const QUOTES = [
  {
    _id: 0,
    day: "Jan 01",
    author: "Nelson Mandela",
    quote:
      "The greatest glory in living lies not in never falling, but in rising every time we fall.",
  },
  {
    _id: 1,
    day: "Jan 02",
    author: "Fred Rogers",
    quote:
      "If you could only sense how important you are to the lives of those you meet; how important you can be to the people you may never even dream of. There is something of yourself that you leave at every meeting with another person.",
  },
  {
    _id: 2,
    day: "Jan 03",
    author: "Eleanor Roosevelt",
    quote:
      "If life were predictable it would cease to be life, and be without flavor.",
  },
  {
    _id: 3,
    day: "Jan 04",
    author: "Oprah Winfrey",
    quote:
      "If you look at what you have in life, you'll always have more. If you look at what you don't have in life, you'll never have enough.",
  },
  {
    _id: 4,
    day: "Jan 05",
    author: "James Cameron",
    quote:
      "If you set your goals ridiculously high and it's a failure, you will fail above everyone else's success.",
  },
  {
    _id: 5,
    day: "Jan 06",
    author: "John Lennon",
    quote: "Life is what happens when you're busy making other plans.",
  },
  {
    _id: 6,
    day: "Jan 07",
    author: "Franklin D. Roosevelt",
    quote: "When you reach the end of your rope, tie a knot in it and hang on.",
  },
  {
    _id: 7,
    day: "Jan 08",
    author: "Robert Louis Stevenson",
    quote:
      "Don't judge each day by the harvest you reap but by the seeds that you plant.",
  },
  {
    _id: 8,
    day: "Jan 09",
    author: "Eleanor Roosevelt",
    quote:
      "The future belongs to those who believe in the beauty of their dreams.",
  },
  {
    _id: 9,
    day: "Jan 10",
    author: "Helen Keller",
    quote:
      "The best and most beautiful things in the world cannot be seen or even touched - they must be felt with the heart.",
  },
  {
    _id: 10,
    day: "Jan 11",
    author: "Anthony Bourdain",
    quote: "I don't have to agree with you to like you or respect you",
  },
  {
    _id: 11,
    day: "Jan 12",
    author: "Anne Frank",
    quote: "Whoever is happy will make others happy too.",
  },
  {
    _id: 12,
    day: "Jan 13",
    author: "Maya Angelou",
    quote:
      "You will face many defeats in life, but never let yourself be defeated.",
  },
  {
    _id: 13,
    day: "Jan 14",
    author: "Abraham Lincoln",
    quote:
      "In the end, it's not the years in your life that count. It's the life in your years.",
  },
  {
    _id: 14,
    day: "Jan 15",
    author: "Babe Ruth",
    quote: "Never let the fear of striking out keep you from playing the game.",
  },
  {
    _id: 15,
    day: "Jan 16",
    author: "Helen Keller",
    quote: "Life is either a daring adventure or nothing at all.",
  },
  {
    _id: 16,
    day: "Jan 17",
    author: "Thomas A. Edison",
    quote:
      "Many of life's failures are people who did not realize how close they were to success when they gave up.",
  },
  {
    _id: 17,
    day: "Jan 18",
    author: "Mae West",
    quote: "You only live once, but if you do it right, once is enough.",
  },
  {
    _id: 18,
    day: "Jan 19",
    author: "James M. Barrie",
    quote: "Life is a long lesson in humility.",
  },
  {
    _id: 19,
    day: "Jan 20",
    author: "Barack Obama",
    quote:
      "The real test is not whether you avoid this failure, because you won't. It's whether you let it harden or shame you into inaction, or whether you learn from it; whether you choose to persevere.",
  },
  {
    _id: 20,
    day: "Jan 21",
    author: "Rosa Parks",
    quote:
      "I have learned over the years that when one's mind is made up, this diminishes fear.",
  },
  {
    _id: 21,
    day: "Jan 22",
    author: "Audrey Hepburn",
    quote: "Nothing is impossible, the word itself says, ‘I'm possible!'",
  },
  {
    _id: 22,
    day: "Jan 23",
    author: "Gloria Steinem",
    quote: "Dreaming, after all, is a form of planning.",
  },
  {
    _id: 23,
    day: "Jan 24",
    author: "Mark Twain",
    quote:
      "Twenty years from now you will be more disappointed by the things that you didn't do than by the ones you did do.",
  },
  {
    _id: 24,
    day: "Jan 25",
    author: "Tony Robbins",
    quote: "The only impossible journey is the one you never begin.",
  },
  {
    _id: 25,
    day: "Jan 26",
    author: "Michael Jordan",
    quote:
      "I've missed more than 9000 shots in my career. I've lost almost 300 games. 26 times I've been trusted to take the game winning shot and missed. I've failed over and over and over again in my life. And that is why I succeed.",
  },
  {
    _id: 26,
    day: "Jan 27",
    author: "Theodore Roosevelt",
    quote: "Do what you can, with what you have, where you are.",
  },
  {
    _id: 27,
    day: "Jan 28",
    author: "Albert Einstein",
    quote:
      "Imagination is everything. It is the preview of life’s coming attractions.",
  },
  {
    _id: 28,
    day: "Jan 29",
    author: "Muhammad Ali",
    quote: "Service to others is the rent you pay for your room here on earth.",
  },
  {
    _id: 29,
    day: "Jan 30",
    author: "Herbert Bayard Swope",
    quote:
      "I can’t give you a sure-fire formula for success, but I can give you a formula for failure: try to please everybody all the time.",
  },
  {
    _id: 30,
    day: "Jan 31",
    author: "J. K Rowling",
    quote:
      "It is our choices, that show what we truly are, far more than our abilities.",
  },
  {
    _id: 31,
    day: "Feb 01",
    author: "Ernest Hemingway",
    quote: "In order to write about life first you must live it.",
  },
  {
    _id: 32,
    day: "Feb 02",
    author: "John Wooden",
    quote: "Do not let making a living prevent you from making a life.",
  },
  {
    _id: 33,
    day: "Feb 03",
    author: "Anthony Bourdain",
    quote:
      "Context and memory play powerful roles in all the truly great meals in one's life.",
  },
  {
    _id: 34,
    day: "Feb 04",
    author: "Harriet Tubman",
    quote:
      "I grew up like a neglected weed - ignorant of liberty, having no experience of it.",
  },
  {
    _id: 35,
    day: "Feb 05",
    author: "Albert Einstein",
    quote: "Any fool can know. The point is to understand.",
  },
  {
    _id: 36,
    day: "Feb 06",
    author: "Anthony Bourdain",
    quote: "Luck is not a business model.",
  },
  {
    _id: 37,
    day: "Feb 07",
    author: "Lucy Maud Montgomery",
    quote:
      "Maybe that's enlightenment enough: to know that there is no final resting place of the mind, no moment of smug clarity. Perhaps wisdom ... is realizing how small I am, and unwise, and how far I have yet to go",
  },
  {
    _id: 38,
    day: "Feb 08",
    author: "William Butler Yates",
    quote:
      "People who lean on logic and philosophy and rational exposition end by starving the best part of the mind.",
  },
  {
    _id: 39,
    day: "Feb 09",
    author: "Lucy Maud Montgomery",
    quote:
      "Even when I'm alone I have real good company — dreams and imaginations and pretendings. I like to be alone now and then, just to think over things and taste them.",
  },
  {
    _id: 40,
    day: "Feb 10",
    author: "Albert Einstein",
    quote: "The only thing that interferes with my learning is my education.",
  },
  {
    _id: 41,
    day: "Feb 11",
    author: "Fred Rogers",
    quote:
      "All of us, at some time or other, need help. Whether we're giving or receiving help, each one of us has something valuable to bring to this world. That's one of the things that connects us as neighbors--in our own way, each one of us is a giver and a receiver.",
  },
  {
    _id: 42,
    day: "Feb 12",
    author: "Lucy Maud Montgomery",
    quote:
      "Don't you just love poetry that gives you a crinkly feeling up and down your back",
  },
  {
    _id: 43,
    day: "Feb 13",
    author: "Albert Einstein",
    quote:
      "The world as we have created it is a process of our thinking. It cannot be changed without changing our thinkin",
  },
  {
    _id: 44,
    day: "Feb 14",
    author: "Rumi",
    quote:
      "Yesterday I was clever, so I wanted to change the world. Today I am wise, so I am changing myself.",
  },
  {
    _id: 45,
    day: "Feb 15",
    author: "Walt Whitman",
    quote:
      "Do I contradict myself? Very well, then, I contradict myself; I am large -- I contain multitudes.",
  },
  {
    _id: 46,
    day: "Feb 16",
    author: "Neil Gaiman",
    quote:
      "Do I contradict myself? Very well, then, I contradict myself; I am large -- I contain multitudes",
  },
  {
    _id: 47,
    day: "Feb 17",
    author: "William Butler Yates",
    quote:
      "This melancholy London - I sometimes imagine that the souls of the lost are compelled to walk through its streets perpetually. One feels them passing like a whiff of air",
  },
  {
    _id: 48,
    day: "Feb 18",
    author: "Lucy Maud Montgomery",
    quote:
      "I don't know that she is as amusing as she was when she was a child, but she makes me love her and I like people who make me love them. It saves me so much trouble in making myself love them.",
  },
  {
    _id: 49,
    day: "Feb 19",
    author: "Aristotle",
    quote:
      "It is during our darkest moments that we must focus to see the light.",
  },
  {
    _id: 50,
    day: "Feb 20",
    author: "Phyllis Diller",
    quote: "Aim high, and you won't shoot your foot off.",
  },
  {
    _id: 51,
    day: "Feb 21",
    author: "Martin Luther King, Jr.",
    quote:
      "We may have all come on different ships, but we're in the same boat now.",
  },
  {
    _id: 52,
    day: "Feb 22",
    author: "Jane Austen",
    quote:
      "I do not want people to be very agreeable, as it saves me the trouble of liking them a great deal.",
  },
  {
    _id: 53,
    day: "Feb 23",
    author: "Friedrich Nietzsche",
    quote: "All truly great thoughts are conceived by walking.",
  },
  {
    _id: 54,
    day: "Feb 24",
    author: "Lucy Maud Montgomery",
    quote:
      "I can't cheer up — I don't want to cheer up. It's nicer to be miserable!",
  },
  {
    _id: 55,
    day: "Feb 25",
    author: "Amelia Earhart",
    quote: "Courage is the price life extracts for granting peace.",
  },
  {
    _id: 56,
    day: "Feb 26",
    author: "Albert Einstein",
    quote:
      "Weak people revenge. Strong people forgive. Intelligent people ignore.",
  },
  {
    _id: 57,
    day: "Feb 27",
    author: "Ansel Adams",
    quote:
      "When words become unclear, I shall focus with photographs. When images become inadequate, I shall be content with silence.",
  },
  {
    _id: 58,
    day: "Feb 28",
    author: "Martin Luther King, Jr.",
    quote:
      "We must accept finite disappointment, but never lose infinite hope.",
  },
  {
    _id: 59,
    day: "Feb 29",
    author: "Desmond Tutu",
    quote:
      "Hope is being able to see that there is light despite all of the darkness. Desmond Tutu",
  },
  {
    _id: 60,
    day: "Mar 01",
    author: "Søren Kierkegaard",
    quote: "Hope is a passion for the possible.",
  },
  {
    _id: 61,
    day: "Mar 02",
    author: "Fred Rogers",
    quote:
      "I don't think anyone can grow unless he's loved exactly as he is now, appreciated for what he is rather than what he will be.",
  },
  {
    _id: 62,
    day: "Mar 03",
    author: "Guillermo Maldonado",
    quote: "Loneliness is not lack of company, loneliness is lack of purpose.",
  },
  {
    _id: 63,
    day: "Mar 04",
    author: "Albert Einstein",
    quote:
      "The woman who follows the crowd will usually go no further than the crowd. The woman who walks alone is likely to find herself in places no one has ever been before.",
  },
  {
    _id: 64,
    day: "Mar 05",
    author: "Henry Rollins",
    quote:
      "Loneliness adds beauty to life. It puts a special burn on sunsets and makes night air smell better.",
  },
  {
    _id: 65,
    day: "Mar 06",
    author: "Hugh MacLeod",
    quote:
      "The price of being a sheep is boredom. The price of being a wolf is loneliness. Choose one or the other with great care.",
  },
  {
    _id: 66,
    day: "Mar 07",
    author: "Lao Tzu",
    quote:
      "Ordinary men hate solitude. But the master makes use of it, embracing his aloneness, realizing he is one with the whole universe.",
  },
  {
    _id: 67,
    day: "Mar 08",
    author: "Mary Sarton",
    quote:
      "Loneliness is the poverty of self; solitude is the richness of self.",
  },
  {
    _id: 68,
    day: "Mar 09",
    author: "Lois Lowry",
    quote:
      "The worst part of holding the memories is not the pain. It’s the loneliness of it. Memories need to be shared.",
  },
  {
    _id: 69,
    day: "Mar 10",
    author: "Naval Ravikant",
    quote:
      "The reality is life is a single-player game. You’re born alone. You’re going to die alone. All of your interpretations are alone. All your memories are alone. You’re gone in three generations and nobody cares. Before you showed up, nobody cared. It’s all single-player.",
  },
  {
    _id: 70,
    day: "Mar 11",
    author: "Albert Einstein",
    quote:
      "Although I am a typical loner in my daily life, my awareness of belonging to the invisible community of those who strive for truth, beauty, and justice has prevented me from feelings of isolation.",
  },
  {
    _id: 71,
    day: "Mar 12",
    author: "Anthony Bourdain",
    quote: "Your body is not a temple, it's an amusement park. Enjoy the ride.",
  },
  {
    _id: 72,
    day: "Mar 13",
    author: "Steve Jobs",
    quote:
      "Your time is limited, so don't waste it living someone else's life. Don't be trapped by dogma – which is living with the results of other people's thinking.",
  },
  {
    _id: 73,
    day: "Mar 14",
    author: "Albert Einstein",
    quote:
      "If you want your children to be intelligent, read them fairy tales. If you want them to be more intelligent, read them more fairy tales",
  },
  {
    _id: 74,
    day: "Mar 15",
    author: "Oscar Wilde",
    quote: "We are all in the gutter, but some of us are looking at the stars.",
  },
  {
    _id: 75,
    day: "Mar 16",
    author: "Albert Einstein",
    quote:
      "Don’t listen to the person who has the answers; listen to the person who has the questions.",
  },
  {
    _id: 76,
    day: "Mar 17",
    author: "Fred Rogers",
    quote:
      "There are times when explanations, no matter how reasonable, just don’t seem to help.",
  },
  {
    _id: 77,
    day: "Mar 18",
    author: "Amelia Earhart",
    quote:
      "In soloing - as in other activities - it is far easier to start something than it is to finish it.",
  },
  {
    _id: 78,
    day: "Mar 19",
    author: "Immanuel Kant",
    quote: "Science is organized knowledge. Wisdom is organized life.",
  },
  {
    _id: 79,
    day: "Mar 20",
    author: "Nelson Mandela",
    quote:
      "The greatest glory in living lies not in never falling, but in rising every time we fall.",
  },
  {
    _id: 80,
    day: "Mar 21",
    author: "Fred Rogers",
    quote:
      "If you could only sense how important you are to the lives of those you meet; how important you can be to the people you may never even dream of. There is something of yourself that you leave at every meeting with another person.",
  },
  {
    _id: 81,
    day: "Mar 22",
    author: "Eleanor Roosevelt",
    quote:
      "If life were predictable it would cease to be life, and be without flavor.",
  },
  {
    _id: 82,
    day: "Mar 23",
    author: "Oprah Winfrey",
    quote:
      "If you look at what you have in life, you'll always have more. If you look at what you don't have in life, you'll never have enough.",
  },
  {
    _id: 83,
    day: "Mar 24",
    author: "James Cameron",
    quote:
      "If you set your goals ridiculously high and it's a failure, you will fail above everyone else's success.",
  },
  {
    _id: 84,
    day: "Mar 25",
    author: "John Lennon",
    quote: "Life is what happens when you're busy making other plans.",
  },
  {
    _id: 85,
    day: "Mar 26",
    author: "Franklin D. Roosevelt",
    quote: "When you reach the end of your rope, tie a knot in it and hang on.",
  },
  {
    _id: 86,
    day: "Mar 27",
    author: "Robert Louis Stevenson",
    quote:
      "Don't judge each day by the harvest you reap but by the seeds that you plant.",
  },
  {
    _id: 87,
    day: "Mar 28",
    author: "Eleanor Roosevelt",
    quote:
      "The future belongs to those who believe in the beauty of their dreams.",
  },
  {
    _id: 88,
    day: "Mar 29",
    author: "Helen Keller",
    quote:
      "The best and most beautiful things in the world cannot be seen or even touched - they must be felt with the heart.",
  },
  {
    _id: 89,
    day: "Mar 30",
    author: "Anthony Bourdain",
    quote: "I don't have to agree with you to like you or respect you",
  },
  {
    _id: 90,
    day: "Mar 31",
    author: "Anne Frank",
    quote: "Whoever is happy will make others happy too.",
  },
  {
    _id: 91,
    day: "Apr 01",
    author: "Maya Angelou",
    quote:
      "You will face many defeats in life, but never let yourself be defeated.",
  },
  {
    _id: 92,
    day: "Apr 02",
    author: "Abraham Lincoln",
    quote:
      "In the end, it's not the years in your life that count. It's the life in your years.",
  },
  {
    _id: 93,
    day: "Apr 03",
    author: "Babe Ruth",
    quote: "Never let the fear of striking out keep you from playing the game.",
  },
  {
    _id: 94,
    day: "Apr 04",
    author: "Helen Keller",
    quote: "Life is either a daring adventure or nothing at all.",
  },
  {
    _id: 95,
    day: "Apr 05",
    author: "Thomas A. Edison",
    quote:
      "Many of life's failures are people who did not realize how close they were to success when they gave up.",
  },
  {
    _id: 96,
    day: "Apr 06",
    author: "Mae West",
    quote: "You only live once, but if you do it right, once is enough.",
  },
  {
    _id: 97,
    day: "Apr 07",
    author: "James M. Barrie",
    quote: "Life is a long lesson in humility.",
  },
  {
    _id: 98,
    day: "Apr 08",
    author: "Barack Obama",
    quote:
      "The real test is not whether you avoid this failure, because you won't. It's whether you let it harden or shame you into inaction, or whether you learn from it; whether you choose to persevere.",
  },
  {
    _id: 99,
    day: "Apr 09",
    author: "Rosa Parks",
    quote:
      "I have learned over the years that when one's mind is made up, this diminishes fear.",
  },
  {
    _id: 100,
    day: "Apr 10",
    author: "Audrey Hepburn",
    quote: "Nothing is impossible, the word itself says, ‘I'm possible!'",
  },
  {
    _id: 101,
    day: "Apr 11",
    author: "Gloria Steinem",
    quote: "Dreaming, after all, is a form of planning.",
  },
  {
    _id: 102,
    day: "Apr 12",
    author: "Mark Twain",
    quote:
      "Twenty years from now you will be more disappointed by the things that you didn't do than by the ones you did do.",
  },
  {
    _id: 103,
    day: "Apr 13",
    author: "Tony Robbins",
    quote: "The only impossible journey is the one you never begin.",
  },
  {
    _id: 104,
    day: "Apr 14",
    author: "Michael Jordan",
    quote:
      "I've missed more than 9000 shots in my career. I've lost almost 300 games. 26 times I've been trusted to take the game winning shot and missed. I've failed over and over and over again in my life. And that is why I succeed.",
  },
  {
    _id: 105,
    day: "Apr 15",
    author: "Theodore Roosevelt",
    quote: "Do what you can, with what you have, where you are.",
  },
  {
    _id: 106,
    day: "Apr 16",
    author: "Albert Einstein",
    quote:
      "Imagination is everything. It is the preview of life’s coming attractions.",
  },
  {
    _id: 107,
    day: "Apr 17",
    author: "Muhammad Ali",
    quote: "Service to others is the rent you pay for your room here on earth.",
  },
  {
    _id: 108,
    day: "Apr 18",
    author: "Herbert Bayard Swope",
    quote:
      "I can’t give you a sure-fire formula for success, but I can give you a formula for failure: try to please everybody all the time.",
  },
  {
    _id: 109,
    day: "Apr 19",
    author: "J. K Rowling",
    quote:
      "It is our choices, that show what we truly are, far more than our abilities.",
  },
  {
    _id: 110,
    day: "Apr 20",
    author: "Ernest Hemingway",
    quote: "In order to write about life first you must live it.",
  },
  {
    _id: 111,
    day: "Apr 21",
    author: "John Wooden",
    quote: "Do not let making a living prevent you from making a life.",
  },
  {
    _id: 112,
    day: "Apr 22",
    author: "Anthony Bourdain",
    quote:
      "Context and memory play powerful roles in all the truly great meals in one's life.",
  },
  {
    _id: 113,
    day: "Apr 23",
    author: "Harriet Tubman",
    quote:
      "I grew up like a neglected weed - ignorant of liberty, having no experience of it.",
  },
  {
    _id: 114,
    day: "Apr 24",
    author: "Albert Einstein",
    quote: "Any fool can know. The point is to understand.",
  },
  {
    _id: 115,
    day: "Apr 25",
    author: "Anthony Bourdain",
    quote: "Luck is not a business model.",
  },
  {
    _id: 116,
    day: "Apr 26",
    author: "Lucy Maud Montgomery",
    quote:
      "Maybe that's enlightenment enough: to know that there is no final resting place of the mind, no moment of smug clarity. Perhaps wisdom ... is realizing how small I am, and unwise, and how far I have yet to go",
  },
  {
    _id: 117,
    day: "Apr 27",
    author: "William Butler Yates",
    quote:
      "People who lean on logic and philosophy and rational exposition end by starving the best part of the mind.",
  },
  {
    _id: 118,
    day: "Apr 28",
    author: "Lucy Maud Montgomery",
    quote:
      "Even when I'm alone I have real good company — dreams and imaginations and pretendings. I like to be alone now and then, just to think over things and taste them.",
  },
  {
    _id: 119,
    day: "Apr 29",
    author: "Albert Einstein",
    quote: "The only thing that interferes with my learning is my education.",
  },
  {
    _id: 120,
    day: "Apr 30",
    author: "Fred Rogers",
    quote:
      "All of us, at some time or other, need help. Whether we're giving or receiving help, each one of us has something valuable to bring to this world. That's one of the things that connects us as neighbors--in our own way, each one of us is a giver and a receiver.",
  },
  {
    _id: 121,
    day: "May 01",
    author: "Lucy Maud Montgomery",
    quote:
      "Don't you just love poetry that gives you a crinkly feeling up and down your back",
  },
  {
    _id: 122,
    day: "May 02",
    author: "Albert Einstein",
    quote:
      "The world as we have created it is a process of our thinking. It cannot be changed without changing our thinkin",
  },
  {
    _id: 123,
    day: "May 03",
    author: "Rumi",
    quote:
      "Yesterday I was clever, so I wanted to change the world. Today I am wise, so I am changing myself.",
  },
  {
    _id: 124,
    day: "May 04",
    author: "Walt Whitman",
    quote:
      "Do I contradict myself? Very well, then, I contradict myself; I am large -- I contain multitudes.",
  },
  {
    _id: 125,
    day: "May 05",
    author: "Neil Gaiman",
    quote:
      "Do I contradict myself? Very well, then, I contradict myself; I am large -- I contain multitudes",
  },
  {
    _id: 126,
    day: "May 06",
    author: "William Butler Yates",
    quote:
      "This melancholy London - I sometimes imagine that the souls of the lost are compelled to walk through its streets perpetually. One feels them passing like a whiff of air",
  },
  {
    _id: 127,
    day: "May 07",
    author: "Lucy Maud Montgomery",
    quote:
      "I don't know that she is as amusing as she was when she was a child, but she makes me love her and I like people who make me love them. It saves me so much trouble in making myself love them.",
  },
  {
    _id: 128,
    day: "May 08",
    author: "Aristotle",
    quote:
      "It is during our darkest moments that we must focus to see the light.",
  },
  {
    _id: 129,
    day: "May 09",
    author: "Phyllis Diller",
    quote: "Aim high, and you won't shoot your foot off.",
  },
  {
    _id: 130,
    day: "May 10",
    author: "Martin Luther King, Jr.",
    quote:
      "We may have all come on different ships, but we're in the same boat now.",
  },
  {
    _id: 131,
    day: "May 11",
    author: "Jane Austen",
    quote:
      "I do not want people to be very agreeable, as it saves me the trouble of liking them a great deal.",
  },
  {
    _id: 132,
    day: "May 12",
    author: "Friedrich Nietzsche",
    quote: "All truly great thoughts are conceived by walking.",
  },
  {
    _id: 133,
    day: "May 13",
    author: "Lucy Maud Montgomery",
    quote:
      "I can't cheer up — I don't want to cheer up. It's nicer to be miserable!",
  },
  {
    _id: 134,
    day: "May 14",
    author: "Amelia Earhart",
    quote: "Courage is the price life extracts for granting peace.",
  },
  {
    _id: 135,
    day: "May 15",
    author: "Albert Einstein",
    quote:
      "Weak people revenge. Strong people forgive. Intelligent people ignore.",
  },
  {
    _id: 136,
    day: "May 16",
    author: "Ansel Adams",
    quote:
      "When words become unclear, I shall focus with photographs. When images become inadequate, I shall be content with silence.",
  },
  {
    _id: 137,
    day: "May 17",
    author: "Martin Luther King, Jr.",
    quote:
      "We must accept finite disappointment, but never lose infinite hope.",
  },
  {
    _id: 138,
    day: "May 18",
    author: "Desmond Tutu",
    quote:
      "Hope is being able to see that there is light despite all of the darkness. Desmond Tutu",
  },
  {
    _id: 139,
    day: "May 19",
    author: "Søren Kierkegaard",
    quote: "Hope is a passion for the possible.",
  },
  {
    _id: 140,
    day: "May 20",
    author: "Fred Rogers",
    quote:
      "I don't think anyone can grow unless he's loved exactly as he is now, appreciated for what he is rather than what he will be.",
  },
  {
    _id: 141,
    day: "May 21",
    author: "Guillermo Maldonado",
    quote: "Loneliness is not lack of company, loneliness is lack of purpose.",
  },
  {
    _id: 142,
    day: "May 22",
    author: "Albert Einstein",
    quote:
      "The woman who follows the crowd will usually go no further than the crowd. The woman who walks alone is likely to find herself in places no one has ever been before.",
  },
  {
    _id: 143,
    day: "May 23",
    author: "Henry Rollins",
    quote:
      "Loneliness adds beauty to life. It puts a special burn on sunsets and makes night air smell better.",
  },
  {
    _id: 144,
    day: "May 24",
    author: "Hugh MacLeod",
    quote:
      "The price of being a sheep is boredom. The price of being a wolf is loneliness. Choose one or the other with great care.",
  },
  {
    _id: 145,
    day: "May 25",
    author: "Lao Tzu",
    quote:
      "Ordinary men hate solitude. But the master makes use of it, embracing his aloneness, realizing he is one with the whole universe.",
  },
  {
    _id: 146,
    day: "May 26",
    author: "Mary Sarton",
    quote:
      "Loneliness is the poverty of self; solitude is the richness of self.",
  },
  {
    _id: 147,
    day: "May 27",
    author: "Lois Lowry",
    quote:
      "The worst part of holding the memories is not the pain. It’s the loneliness of it. Memories need to be shared.",
  },
  {
    _id: 148,
    day: "May 28",
    author: "Naval Ravikant",
    quote:
      "The reality is life is a single-player game. You’re born alone. You’re going to die alone. All of your interpretations are alone. All your memories are alone. You’re gone in three generations and nobody cares. Before you showed up, nobody cared. It’s all single-player.",
  },
  {
    _id: 149,
    day: "May 29",
    author: "Albert Einstein",
    quote:
      "Although I am a typical loner in my daily life, my awareness of belonging to the invisible community of those who strive for truth, beauty, and justice has prevented me from feelings of isolation.",
  },
  {
    _id: 150,
    day: "May 30",
    author: "Anthony Bourdain",
    quote: "Your body is not a temple, it's an amusement park. Enjoy the ride.",
  },
  {
    _id: 151,
    day: "May 31",
    author: "Steve Jobs",
    quote:
      "Your time is limited, so don't waste it living someone else's life. Don't be trapped by dogma – which is living with the results of other people's thinking.",
  },
  {
    _id: 152,
    day: "Jun 01",
    author: "Albert Einstein",
    quote:
      "If you want your children to be intelligent, read them fairy tales. If you want them to be more intelligent, read them more fairy tales",
  },
  {
    _id: 153,
    day: "Jun 02",
    author: "Oscar Wilde",
    quote: "We are all in the gutter, but some of us are looking at the stars.",
  },
  {
    _id: 154,
    day: "Jun 03",
    author: "Albert Einstein",
    quote:
      "Don’t listen to the person who has the answers; listen to the person who has the questions.",
  },
  {
    _id: 155,
    day: "Jun 04",
    author: "Fred Rogers",
    quote:
      "There are times when explanations, no matter how reasonable, just don’t seem to help.",
  },
  {
    _id: 156,
    day: "Jun 05",
    author: "Amelia Earhart",
    quote:
      "In soloing - as in other activities - it is far easier to start something than it is to finish it.",
  },
  {
    _id: 157,
    day: "Jun 06",
    author: "Immanuel Kant",
    quote: "Science is organized knowledge. Wisdom is organized life.",
  },
  {
    _id: 158,
    day: "Jun 07",
    author: "Nelson Mandela",
    quote:
      "The greatest glory in living lies not in never falling, but in rising every time we fall.",
  },
  {
    _id: 159,
    day: "Jun 08",
    author: "Fred Rogers",
    quote:
      "If you could only sense how important you are to the lives of those you meet; how important you can be to the people you may never even dream of. There is something of yourself that you leave at every meeting with another person.",
  },
  {
    _id: 160,
    day: "Jun 09",
    author: "Eleanor Roosevelt",
    quote:
      "If life were predictable it would cease to be life, and be without flavor.",
  },
  {
    _id: 161,
    day: "Jun 10",
    author: "Oprah Winfrey",
    quote:
      "If you look at what you have in life, you'll always have more. If you look at what you don't have in life, you'll never have enough.",
  },
  {
    _id: 162,
    day: "Jun 11",
    author: "James Cameron",
    quote:
      "If you set your goals ridiculously high and it's a failure, you will fail above everyone else's success.",
  },
  {
    _id: 163,
    day: "Jun 12",
    author: "John Lennon",
    quote: "Life is what happens when you're busy making other plans.",
  },
  {
    _id: 164,
    day: "Jun 13",
    author: "Franklin D. Roosevelt",
    quote: "When you reach the end of your rope, tie a knot in it and hang on.",
  },
  {
    _id: 165,
    day: "Jun 14",
    author: "Robert Louis Stevenson",
    quote:
      "Don't judge each day by the harvest you reap but by the seeds that you plant.",
  },
  {
    _id: 166,
    day: "Jun 15",
    author: "Eleanor Roosevelt",
    quote:
      "The future belongs to those who believe in the beauty of their dreams.",
  },
  {
    _id: 167,
    day: "Jun 16",
    author: "Helen Keller",
    quote:
      "The best and most beautiful things in the world cannot be seen or even touched - they must be felt with the heart.",
  },
  {
    _id: 168,
    day: "Jun 17",
    author: "Anthony Bourdain",
    quote: "I don't have to agree with you to like you or respect you",
  },
  {
    _id: 169,
    day: "Jun 18",
    author: "Anne Frank",
    quote: "Whoever is happy will make others happy too.",
  },
  {
    _id: 170,
    day: "Jun 19",
    author: "Maya Angelou",
    quote:
      "You will face many defeats in life, but never let yourself be defeated.",
  },
  {
    _id: 171,
    day: "Jun 20",
    author: "Abraham Lincoln",
    quote:
      "In the end, it's not the years in your life that count. It's the life in your years.",
  },
  {
    _id: 172,
    day: "Jun 21",
    author: "Babe Ruth",
    quote: "Never let the fear of striking out keep you from playing the game.",
  },
  {
    _id: 173,
    day: "Jun 22",
    author: "Helen Keller",
    quote: "Life is either a daring adventure or nothing at all.",
  },
  {
    _id: 174,
    day: "Jun 23",
    author: "Thomas A. Edison",
    quote:
      "Many of life's failures are people who did not realize how close they were to success when they gave up.",
  },
  {
    _id: 175,
    day: "Jun 24",
    author: "Mae West",
    quote: "You only live once, but if you do it right, once is enough.",
  },
  {
    _id: 176,
    day: "Jun 25",
    author: "James M. Barrie",
    quote: "Life is a long lesson in humility.",
  },
  {
    _id: 177,
    day: "Jun 26",
    author: "Barack Obama",
    quote:
      "The real test is not whether you avoid this failure, because you won't. It's whether you let it harden or shame you into inaction, or whether you learn from it; whether you choose to persevere.",
  },
  {
    _id: 178,
    day: "Jun 27",
    author: "Rosa Parks",
    quote:
      "I have learned over the years that when one's mind is made up, this diminishes fear.",
  },
  {
    _id: 179,
    day: "Jun 28",
    author: "Audrey Hepburn",
    quote: "Nothing is impossible, the word itself says, ‘I'm possible!'",
  },
  {
    _id: 180,
    day: "Jun 29",
    author: "Gloria Steinem",
    quote: "Dreaming, after all, is a form of planning.",
  },
  {
    _id: 181,
    day: "Jun 30",
    author: "Mark Twain",
    quote:
      "Twenty years from now you will be more disappointed by the things that you didn't do than by the ones you did do.",
  },
  {
    _id: 182,
    day: "Jul 01",
    author: "Tony Robbins",
    quote: "The only impossible journey is the one you never begin.",
  },
  {
    _id: 183,
    day: "Jul 02",
    author: "Michael Jordan",
    quote:
      "I've missed more than 9000 shots in my career. I've lost almost 300 games. 26 times I've been trusted to take the game winning shot and missed. I've failed over and over and over again in my life. And that is why I succeed.",
  },
  {
    _id: 184,
    day: "Jul 03",
    author: "Theodore Roosevelt",
    quote: "Do what you can, with what you have, where you are.",
  },
  {
    _id: 185,
    day: "Jul 04",
    author: "Albert Einstein",
    quote:
      "Imagination is everything. It is the preview of life’s coming attractions.",
  },
  {
    _id: 186,
    day: "Jul 05",
    author: "Muhammad Ali",
    quote: "Service to others is the rent you pay for your room here on earth.",
  },
  {
    _id: 187,
    day: "Jul 06",
    author: "Herbert Bayard Swope",
    quote:
      "I can’t give you a sure-fire formula for success, but I can give you a formula for failure: try to please everybody all the time.",
  },
  {
    _id: 188,
    day: "Jul 07",
    author: "J. K Rowling",
    quote:
      "It is our choices, that show what we truly are, far more than our abilities.",
  },
  {
    _id: 189,
    day: "Jul 08",
    author: "Ernest Hemingway",
    quote: "In order to write about life first you must live it.",
  },
  {
    _id: 190,
    day: "Jul 09",
    author: "John Wooden",
    quote: "Do not let making a living prevent you from making a life.",
  },
  {
    _id: 191,
    day: "Jul 10",
    author: "Anthony Bourdain",
    quote:
      "Context and memory play powerful roles in all the truly great meals in one's life.",
  },
  {
    _id: 192,
    day: "Jul 11",
    author: "Harriet Tubman",
    quote:
      "I grew up like a neglected weed - ignorant of liberty, having no experience of it.",
  },
  {
    _id: 193,
    day: "Jul 12",
    author: "Albert Einstein",
    quote: "Any fool can know. The point is to understand.",
  },
  {
    _id: 194,
    day: "Jul 13",
    author: "Anthony Bourdain",
    quote: "Luck is not a business model.",
  },
  {
    _id: 195,
    day: "Jul 14",
    author: "Lucy Maud Montgomery",
    quote:
      "Maybe that's enlightenment enough: to know that there is no final resting place of the mind, no moment of smug clarity. Perhaps wisdom ... is realizing how small I am, and unwise, and how far I have yet to go",
  },
  {
    _id: 196,
    day: "Jul 15",
    author: "William Butler Yates",
    quote:
      "People who lean on logic and philosophy and rational exposition end by starving the best part of the mind.",
  },
  {
    _id: 197,
    day: "Jul 16",
    author: "Lucy Maud Montgomery",
    quote:
      "Even when I'm alone I have real good company — dreams and imaginations and pretendings. I like to be alone now and then, just to think over things and taste them.",
  },
  {
    _id: 198,
    day: "Jul 17",
    author: "Albert Einstein",
    quote: "The only thing that interferes with my learning is my education.",
  },
  {
    _id: 199,
    day: "Jul 18",
    author: "Fred Rogers",
    quote:
      "All of us, at some time or other, need help. Whether we're giving or receiving help, each one of us has something valuable to bring to this world. That's one of the things that connects us as neighbors--in our own way, each one of us is a giver and a receiver.",
  },
  {
    _id: 200,
    day: "Jul 19",
    author: "Lucy Maud Montgomery",
    quote:
      "Don't you just love poetry that gives you a crinkly feeling up and down your back",
  },
  {
    _id: 201,
    day: "Jul 20",
    author: "Albert Einstein",
    quote:
      "The world as we have created it is a process of our thinking. It cannot be changed without changing our thinkin",
  },
  {
    _id: 202,
    day: "Jul 21",
    author: "Rumi",
    quote:
      "Yesterday I was clever, so I wanted to change the world. Today I am wise, so I am changing myself.",
  },
  {
    _id: 203,
    day: "Jul 22",
    author: "Walt Whitman",
    quote:
      "Do I contradict myself? Very well, then, I contradict myself; I am large -- I contain multitudes.",
  },
  {
    _id: 204,
    day: "Jul 23",
    author: "Neil Gaiman",
    quote:
      "Do I contradict myself? Very well, then, I contradict myself; I am large -- I contain multitudes",
  },
  {
    _id: 205,
    day: "Jul 24",
    author: "William Butler Yates",
    quote:
      "This melancholy London - I sometimes imagine that the souls of the lost are compelled to walk through its streets perpetually. One feels them passing like a whiff of air",
  },
  {
    _id: 206,
    day: "Jul 25",
    author: "Lucy Maud Montgomery",
    quote:
      "I don't know that she is as amusing as she was when she was a child, but she makes me love her and I like people who make me love them. It saves me so much trouble in making myself love them.",
  },
  {
    _id: 207,
    day: "Jul 26",
    author: "Aristotle",
    quote:
      "It is during our darkest moments that we must focus to see the light.",
  },
  {
    _id: 208,
    day: "Jul 27",
    author: "Phyllis Diller",
    quote: "Aim high, and you won't shoot your foot off.",
  },
  {
    _id: 209,
    day: "Jul 28",
    author: "Martin Luther King, Jr.",
    quote:
      "We may have all come on different ships, but we're in the same boat now.",
  },
  {
    _id: 210,
    day: "Jul 29",
    author: "Jane Austen",
    quote:
      "I do not want people to be very agreeable, as it saves me the trouble of liking them a great deal.",
  },
  {
    _id: 211,
    day: "Jul 30",
    author: "Friedrich Nietzsche",
    quote: "All truly great thoughts are conceived by walking.",
  },
  {
    _id: 212,
    day: "Jul 31",
    author: "Lucy Maud Montgomery",
    quote:
      "I can't cheer up — I don't want to cheer up. It's nicer to be miserable!",
  },
  {
    _id: 213,
    day: "Aug 01",
    author: "Amelia Earhart",
    quote: "Courage is the price life extracts for granting peace.",
  },
  {
    _id: 214,
    day: "Aug 02",
    author: "Albert Einstein",
    quote:
      "Weak people revenge. Strong people forgive. Intelligent people ignore.",
  },
  {
    _id: 215,
    day: "Aug 03",
    author: "Ansel Adams",
    quote:
      "When words become unclear, I shall focus with photographs. When images become inadequate, I shall be content with silence.",
  },
  {
    _id: 216,
    day: "Aug 04",
    author: "Martin Luther King, Jr.",
    quote:
      "We must accept finite disappointment, but never lose infinite hope.",
  },
  {
    _id: 217,
    day: "Aug 05",
    author: "Desmond Tutu",
    quote:
      "Hope is being able to see that there is light despite all of the darkness. Desmond Tutu",
  },
  {
    _id: 218,
    day: "Aug 06",
    author: "Søren Kierkegaard",
    quote: "Hope is a passion for the possible.",
  },
  {
    _id: 219,
    day: "Aug 07",
    author: "Fred Rogers",
    quote:
      "I don't think anyone can grow unless he's loved exactly as he is now, appreciated for what he is rather than what he will be.",
  },
  {
    _id: 220,
    day: "Aug 08",
    author: "Guillermo Maldonado",
    quote: "Loneliness is not lack of company, loneliness is lack of purpose.",
  },
  {
    _id: 221,
    day: "Aug 09",
    author: "Albert Einstein",
    quote:
      "The woman who follows the crowd will usually go no further than the crowd. The woman who walks alone is likely to find herself in places no one has ever been before.",
  },
  {
    _id: 222,
    day: "Aug 10",
    author: "Henry Rollins",
    quote:
      "Loneliness adds beauty to life. It puts a special burn on sunsets and makes night air smell better.",
  },
  {
    _id: 223,
    day: "Aug 11",
    author: "Hugh MacLeod",
    quote:
      "The price of being a sheep is boredom. The price of being a wolf is loneliness. Choose one or the other with great care.",
  },
  {
    _id: 224,
    day: "Aug 12",
    author: "Lao Tzu",
    quote:
      "Ordinary men hate solitude. But the master makes use of it, embracing his aloneness, realizing he is one with the whole universe.",
  },
  {
    _id: 225,
    day: "Aug 13",
    author: "Mary Sarton",
    quote:
      "Loneliness is the poverty of self; solitude is the richness of self.",
  },
  {
    _id: 226,
    day: "Aug 14",
    author: "Lois Lowry",
    quote:
      "The worst part of holding the memories is not the pain. It’s the loneliness of it. Memories need to be shared.",
  },
  {
    _id: 227,
    day: "Aug 15",
    author: "Naval Ravikant",
    quote:
      "The reality is life is a single-player game. You’re born alone. You’re going to die alone. All of your interpretations are alone. All your memories are alone. You’re gone in three generations and nobody cares. Before you showed up, nobody cared. It’s all single-player.",
  },
  {
    _id: 228,
    day: "Aug 16",
    author: "Albert Einstein",
    quote:
      "Although I am a typical loner in my daily life, my awareness of belonging to the invisible community of those who strive for truth, beauty, and justice has prevented me from feelings of isolation.",
  },
  {
    _id: 229,
    day: "Aug 17",
    author: "Anthony Bourdain",
    quote: "Your body is not a temple, it's an amusement park. Enjoy the ride.",
  },
  {
    _id: 230,
    day: "Aug 18",
    author: "Steve Jobs",
    quote:
      "Your time is limited, so don't waste it living someone else's life. Don't be trapped by dogma – which is living with the results of other people's thinking.",
  },
  {
    _id: 231,
    day: "Aug 19",
    author: "Albert Einstein",
    quote:
      "If you want your children to be intelligent, read them fairy tales. If you want them to be more intelligent, read them more fairy tales",
  },
  {
    _id: 232,
    day: "Aug 20",
    author: "Oscar Wilde",
    quote: "We are all in the gutter, but some of us are looking at the stars.",
  },
  {
    _id: 233,
    day: "Aug 21",
    author: "Albert Einstein",
    quote:
      "Don’t listen to the person who has the answers; listen to the person who has the questions.",
  },
  {
    _id: 234,
    day: "Aug 22",
    author: "Fred Rogers",
    quote:
      "There are times when explanations, no matter how reasonable, just don’t seem to help.",
  },
  {
    _id: 235,
    day: "Aug 23",
    author: "Amelia Earhart",
    quote:
      "In soloing - as in other activities - it is far easier to start something than it is to finish it.",
  },
  {
    _id: 236,
    day: "Aug 24",
    author: "Immanuel Kant",
    quote: "Science is organized knowledge. Wisdom is organized life.",
  },
  {
    _id: 237,
    day: "Aug 25",
    author: "Nelson Mandela",
    quote:
      "The greatest glory in living lies not in never falling, but in rising every time we fall.",
  },
  {
    _id: 238,
    day: "Aug 26",
    author: "Fred Rogers",
    quote:
      "If you could only sense how important you are to the lives of those you meet; how important you can be to the people you may never even dream of. There is something of yourself that you leave at every meeting with another person.",
  },
  {
    _id: 239,
    day: "Aug 27",
    author: "Eleanor Roosevelt",
    quote:
      "If life were predictable it would cease to be life, and be without flavor.",
  },
  {
    _id: 240,
    day: "Aug 28",
    author: "Oprah Winfrey",
    quote:
      "If you look at what you have in life, you'll always have more. If you look at what you don't have in life, you'll never have enough.",
  },
  {
    _id: 241,
    day: "Aug 29",
    author: "James Cameron",
    quote:
      "If you set your goals ridiculously high and it's a failure, you will fail above everyone else's success.",
  },
  {
    _id: 242,
    day: "Aug 30",
    author: "John Lennon",
    quote: "Life is what happens when you're busy making other plans.",
  },
  {
    _id: 243,
    day: "Aug 31",
    author: "Franklin D. Roosevelt",
    quote: "When you reach the end of your rope, tie a knot in it and hang on.",
  },
  {
    _id: 244,
    day: "Sep 01",
    author: "Robert Louis Stevenson",
    quote:
      "Don't judge each day by the harvest you reap but by the seeds that you plant.",
  },
  {
    _id: 245,
    day: "Sep 02",
    author: "Eleanor Roosevelt",
    quote:
      "The future belongs to those who believe in the beauty of their dreams.",
  },
  {
    _id: 246,
    day: "Sep 03",
    author: "Helen Keller",
    quote:
      "The best and most beautiful things in the world cannot be seen or even touched - they must be felt with the heart.",
  },
  {
    _id: 247,
    day: "Sep 04",
    author: "Anthony Bourdain",
    quote: "I don't have to agree with you to like you or respect you",
  },
  {
    _id: 248,
    day: "Sep 05",
    author: "Anne Frank",
    quote: "Whoever is happy will make others happy too.",
  },
  {
    _id: 249,
    day: "Sep 06",
    author: "Maya Angelou",
    quote:
      "You will face many defeats in life, but never let yourself be defeated.",
  },
  {
    _id: 250,
    day: "Sep 07",
    author: "Abraham Lincoln",
    quote:
      "In the end, it's not the years in your life that count. It's the life in your years.",
  },
  {
    _id: 251,
    day: "Sep 08",
    author: "Babe Ruth",
    quote: "Never let the fear of striking out keep you from playing the game.",
  },
  {
    _id: 252,
    day: "Sep 09",
    author: "Helen Keller",
    quote: "Life is either a daring adventure or nothing at all.",
  },
  {
    _id: 253,
    day: "Sep 10",
    author: "Thomas A. Edison",
    quote:
      "Many of life's failures are people who did not realize how close they were to success when they gave up.",
  },
  {
    _id: 254,
    day: "Sep 11",
    author: "Mae West",
    quote: "You only live once, but if you do it right, once is enough.",
  },
  {
    _id: 255,
    day: "Sep 12",
    author: "James M. Barrie",
    quote: "Life is a long lesson in humility.",
  },
  {
    _id: 256,
    day: "Sep 13",
    author: "Barack Obama",
    quote:
      "The real test is not whether you avoid this failure, because you won't. It's whether you let it harden or shame you into inaction, or whether you learn from it; whether you choose to persevere.",
  },
  {
    _id: 257,
    day: "Sep 14",
    author: "Rosa Parks",
    quote:
      "I have learned over the years that when one's mind is made up, this diminishes fear.",
  },
  {
    _id: 258,
    day: "Sep 15",
    author: "Audrey Hepburn",
    quote: "Nothing is impossible, the word itself says, ‘I'm possible!'",
  },
  {
    _id: 259,
    day: "Sep 16",
    author: "Gloria Steinem",
    quote: "Dreaming, after all, is a form of planning.",
  },
  {
    _id: 260,
    day: "Sep 17",
    author: "Mark Twain",
    quote:
      "Twenty years from now you will be more disappointed by the things that you didn't do than by the ones you did do.",
  },
  {
    _id: 261,
    day: "Sep 18",
    author: "Tony Robbins",
    quote: "The only impossible journey is the one you never begin.",
  },
  {
    _id: 262,
    day: "Sep 19",
    author: "Michael Jordan",
    quote:
      "I've missed more than 9000 shots in my career. I've lost almost 300 games. 26 times I've been trusted to take the game winning shot and missed. I've failed over and over and over again in my life. And that is why I succeed.",
  },
  {
    _id: 263,
    day: "Sep 20",
    author: "Theodore Roosevelt",
    quote: "Do what you can, with what you have, where you are.",
  },
  {
    _id: 264,
    day: "Sep 21",
    author: "Albert Einstein",
    quote:
      "Imagination is everything. It is the preview of life’s coming attractions.",
  },
  {
    _id: 265,
    day: "Sep 22",
    author: "Muhammad Ali",
    quote: "Service to others is the rent you pay for your room here on earth.",
  },
  {
    _id: 266,
    day: "Sep 23",
    author: "Herbert Bayard Swope",
    quote:
      "I can’t give you a sure-fire formula for success, but I can give you a formula for failure: try to please everybody all the time.",
  },
  {
    _id: 267,
    day: "Sep 24",
    author: "J. K Rowling",
    quote:
      "It is our choices, that show what we truly are, far more than our abilities.",
  },
  {
    _id: 268,
    day: "Sep 25",
    author: "Ernest Hemingway",
    quote: "In order to write about life first you must live it.",
  },
  {
    _id: 269,
    day: "Sep 26",
    author: "John Wooden",
    quote: "Do not let making a living prevent you from making a life.",
  },
  {
    _id: 270,
    day: "Sep 27",
    author: "Anthony Bourdain",
    quote:
      "Context and memory play powerful roles in all the truly great meals in one's life.",
  },
  {
    _id: 271,
    day: "Sep 28",
    author: "Harriet Tubman",
    quote:
      "I grew up like a neglected weed - ignorant of liberty, having no experience of it.",
  },
  {
    _id: 272,
    day: "Sep 29",
    author: "Albert Einstein",
    quote: "Any fool can know. The point is to understand.",
  },
  {
    _id: 273,
    day: "Sep 30",
    author: "Anthony Bourdain",
    quote: "Luck is not a business model.",
  },
  {
    _id: 274,
    day: "Oct 01",
    author: "Lucy Maud Montgomery",
    quote:
      "Maybe that's enlightenment enough: to know that there is no final resting place of the mind, no moment of smug clarity. Perhaps wisdom ... is realizing how small I am, and unwise, and how far I have yet to go",
  },
  {
    _id: 275,
    day: "Oct 02",
    author: "William Butler Yates",
    quote:
      "People who lean on logic and philosophy and rational exposition end by starving the best part of the mind.",
  },
  {
    _id: 276,
    day: "Oct 03",
    author: "Lucy Maud Montgomery",
    quote:
      "Even when I'm alone I have real good company — dreams and imaginations and pretendings. I like to be alone now and then, just to think over things and taste them.",
  },
  {
    _id: 277,
    day: "Oct 04",
    author: "Albert Einstein",
    quote: "The only thing that interferes with my learning is my education.",
  },
  {
    _id: 278,
    day: "Oct 05",
    author: "Fred Rogers",
    quote:
      "All of us, at some time or other, need help. Whether we're giving or receiving help, each one of us has something valuable to bring to this world. That's one of the things that connects us as neighbors--in our own way, each one of us is a giver and a receiver.",
  },
  {
    _id: 279,
    day: "Oct 06",
    author: "Lucy Maud Montgomery",
    quote:
      "Don't you just love poetry that gives you a crinkly feeling up and down your back",
  },
  {
    _id: 280,
    day: "Oct 07",
    author: "Albert Einstein",
    quote:
      "The world as we have created it is a process of our thinking. It cannot be changed without changing our thinkin",
  },
  {
    _id: 281,
    day: "Oct 08",
    author: "Rumi",
    quote:
      "Yesterday I was clever, so I wanted to change the world. Today I am wise, so I am changing myself.",
  },
  {
    _id: 282,
    day: "Oct 09",
    author: "Walt Whitman",
    quote:
      "Do I contradict myself? Very well, then, I contradict myself; I am large -- I contain multitudes.",
  },
  {
    _id: 283,
    day: "Oct 10",
    author: "Neil Gaiman",
    quote:
      "Do I contradict myself? Very well, then, I contradict myself; I am large -- I contain multitudes",
  },
  {
    _id: 284,
    day: "Oct 11",
    author: "William Butler Yates",
    quote:
      "This melancholy London - I sometimes imagine that the souls of the lost are compelled to walk through its streets perpetually. One feels them passing like a whiff of air",
  },
  {
    _id: 285,
    day: "Oct 12",
    author: "Lucy Maud Montgomery",
    quote:
      "I don't know that she is as amusing as she was when she was a child, but she makes me love her and I like people who make me love them. It saves me so much trouble in making myself love them.",
  },
  {
    _id: 286,
    day: "Oct 13",
    author: "Aristotle",
    quote:
      "It is during our darkest moments that we must focus to see the light.",
  },
  {
    _id: 287,
    day: "Oct 14",
    author: "Phyllis Diller",
    quote: "Aim high, and you won't shoot your foot off.",
  },
  {
    _id: 288,
    day: "Oct 15",
    author: "Martin Luther King, Jr.",
    quote:
      "We may have all come on different ships, but we're in the same boat now.",
  },
  {
    _id: 289,
    day: "Oct 16",
    author: "Jane Austen",
    quote:
      "I do not want people to be very agreeable, as it saves me the trouble of liking them a great deal.",
  },
  {
    _id: 290,
    day: "Oct 17",
    author: "Friedrich Nietzsche",
    quote: "All truly great thoughts are conceived by walking.",
  },
  {
    _id: 291,
    day: "Oct 18",
    author: "Lucy Maud Montgomery",
    quote:
      "I can't cheer up — I don't want to cheer up. It's nicer to be miserable!",
  },
  {
    _id: 292,
    day: "Oct 19",
    author: "Amelia Earhart",
    quote: "Courage is the price life extracts for granting peace.",
  },
  {
    _id: 293,
    day: "Oct 20",
    author: "Albert Einstein",
    quote:
      "Weak people revenge. Strong people forgive. Intelligent people ignore.",
  },
  {
    _id: 294,
    day: "Oct 21",
    author: "Ansel Adams",
    quote:
      "When words become unclear, I shall focus with photographs. When images become inadequate, I shall be content with silence.",
  },
  {
    _id: 295,
    day: "Oct 22",
    author: "Martin Luther King, Jr.",
    quote:
      "We must accept finite disappointment, but never lose infinite hope.",
  },
  {
    _id: 296,
    day: "Oct 23",
    author: "Desmond Tutu",
    quote:
      "Hope is being able to see that there is light despite all of the darkness. Desmond Tutu",
  },
  {
    _id: 297,
    day: "Oct 24",
    author: "Søren Kierkegaard",
    quote: "Hope is a passion for the possible.",
  },
  {
    _id: 298,
    day: "Oct 25",
    author: "Fred Rogers",
    quote:
      "I don't think anyone can grow unless he's loved exactly as he is now, appreciated for what he is rather than what he will be.",
  },
  {
    _id: 299,
    day: "Oct 26",
    author: "Guillermo Maldonado",
    quote: "Loneliness is not lack of company, loneliness is lack of purpose.",
  },
  {
    _id: 300,
    day: "Oct 27",
    author: "Albert Einstein",
    quote:
      "The woman who follows the crowd will usually go no further than the crowd. The woman who walks alone is likely to find herself in places no one has ever been before.",
  },
  {
    _id: 301,
    day: "Oct 28",
    author: "Henry Rollins",
    quote:
      "Loneliness adds beauty to life. It puts a special burn on sunsets and makes night air smell better.",
  },
  {
    _id: 302,
    day: "Oct 29",
    author: "Hugh MacLeod",
    quote:
      "The price of being a sheep is boredom. The price of being a wolf is loneliness. Choose one or the other with great care.",
  },
  {
    _id: 303,
    day: "Oct 30",
    author: "Lao Tzu",
    quote:
      "Ordinary men hate solitude. But the master makes use of it, embracing his aloneness, realizing he is one with the whole universe.",
  },
  {
    _id: 304,
    day: "Oct 31",
    author: "Mary Sarton",
    quote:
      "Loneliness is the poverty of self; solitude is the richness of self.",
  },
  {
    _id: 305,
    day: "Nov 01",
    author: "Lois Lowry",
    quote:
      "The worst part of holding the memories is not the pain. It’s the loneliness of it. Memories need to be shared.",
  },
  {
    _id: 306,
    day: "Nov 02",
    author: "Naval Ravikant",
    quote:
      "The reality is life is a single-player game. You’re born alone. You’re going to die alone. All of your interpretations are alone. All your memories are alone. You’re gone in three generations and nobody cares. Before you showed up, nobody cared. It’s all single-player.",
  },
  {
    _id: 307,
    day: "Nov 03",
    author: "Albert Einstein",
    quote:
      "Although I am a typical loner in my daily life, my awareness of belonging to the invisible community of those who strive for truth, beauty, and justice has prevented me from feelings of isolation.",
  },
  {
    _id: 308,
    day: "Nov 04",
    author: "Anthony Bourdain",
    quote: "Your body is not a temple, it's an amusement park. Enjoy the ride.",
  },
  {
    _id: 309,
    day: "Nov 05",
    author: "Steve Jobs",
    quote:
      "Your time is limited, so don't waste it living someone else's life. Don't be trapped by dogma – which is living with the results of other people's thinking.",
  },
  {
    _id: 310,
    day: "Nov 06",
    author: "Albert Einstein",
    quote:
      "If you want your children to be intelligent, read them fairy tales. If you want them to be more intelligent, read them more fairy tales",
  },
  {
    _id: 311,
    day: "Nov 07",
    author: "Oscar Wilde",
    quote: "We are all in the gutter, but some of us are looking at the stars.",
  },
  {
    _id: 312,
    day: "Nov 08",
    author: "Albert Einstein",
    quote:
      "Don’t listen to the person who has the answers; listen to the person who has the questions.",
  },
  {
    _id: 313,
    day: "Nov 09",
    author: "Fred Rogers",
    quote:
      "There are times when explanations, no matter how reasonable, just don’t seem to help.",
  },
  {
    _id: 314,
    day: "Nov 10",
    author: "Amelia Earhart",
    quote:
      "In soloing - as in other activities - it is far easier to start something than it is to finish it.",
  },
  {
    _id: 315,
    day: "Nov 11",
    author: "Immanuel Kant",
    quote: "Science is organized knowledge. Wisdom is organized life.",
  },
  {
    _id: 316,
    day: "Nov 12",
    author: "Nelson Mandela",
    quote:
      "The greatest glory in living lies not in never falling, but in rising every time we fall.",
  },
  {
    _id: 317,
    day: "Nov 13",
    author: "Fred Rogers",
    quote:
      "If you could only sense how important you are to the lives of those you meet; how important you can be to the people you may never even dream of. There is something of yourself that you leave at every meeting with another person.",
  },
  {
    _id: 318,
    day: "Nov 14",
    author: "Eleanor Roosevelt",
    quote:
      "If life were predictable it would cease to be life, and be without flavor.",
  },
  {
    _id: 319,
    day: "Nov 15",
    author: "Oprah Winfrey",
    quote:
      "If you look at what you have in life, you'll always have more. If you look at what you don't have in life, you'll never have enough.",
  },
  {
    _id: 320,
    day: "Nov 16",
    author: "James Cameron",
    quote:
      "If you set your goals ridiculously high and it's a failure, you will fail above everyone else's success.",
  },
  {
    _id: 321,
    day: "Nov 17",
    author: "John Lennon",
    quote: "Life is what happens when you're busy making other plans.",
  },
  {
    _id: 322,
    day: "Nov 18",
    author: "Franklin D. Roosevelt",
    quote: "When you reach the end of your rope, tie a knot in it and hang on.",
  },
  {
    _id: 323,
    day: "Nov 19",
    author: "Robert Louis Stevenson",
    quote:
      "Don't judge each day by the harvest you reap but by the seeds that you plant.",
  },
  {
    _id: 324,
    day: "Nov 20",
    author: "Eleanor Roosevelt",
    quote:
      "The future belongs to those who believe in the beauty of their dreams.",
  },
  {
    _id: 325,
    day: "Nov 21",
    author: "Helen Keller",
    quote:
      "The best and most beautiful things in the world cannot be seen or even touched - they must be felt with the heart.",
  },
  {
    _id: 326,
    day: "Nov 22",
    author: "Anthony Bourdain",
    quote: "I don't have to agree with you to like you or respect you",
  },
  {
    _id: 327,
    day: "Nov 23",
    author: "Anne Frank",
    quote: "Whoever is happy will make others happy too.",
  },
  {
    _id: 328,
    day: "Nov 24",
    author: "Maya Angelou",
    quote:
      "You will face many defeats in life, but never let yourself be defeated.",
  },
  {
    _id: 329,
    day: "Nov 25",
    author: "Abraham Lincoln",
    quote:
      "In the end, it's not the years in your life that count. It's the life in your years.",
  },
  {
    _id: 330,
    day: "Nov 26",
    author: "Babe Ruth",
    quote: "Never let the fear of striking out keep you from playing the game.",
  },
  {
    _id: 331,
    day: "Nov 27",
    author: "Helen Keller",
    quote: "Life is either a daring adventure or nothing at all.",
  },
  {
    _id: 332,
    day: "Nov 28",
    author: "Thomas A. Edison",
    quote:
      "Many of life's failures are people who did not realize how close they were to success when they gave up.",
  },
  {
    _id: 333,
    day: "Nov 29",
    author: "Mae West",
    quote: "You only live once, but if you do it right, once is enough.",
  },
  {
    _id: 334,
    day: "Nov 30",
    author: "James M. Barrie",
    quote: "Life is a long lesson in humility.",
  },
  {
    _id: 335,
    day: "Dec 01",
    author: "Barack Obama",
    quote:
      "The real test is not whether you avoid this failure, because you won't. It's whether you let it harden or shame you into inaction, or whether you learn from it; whether you choose to persevere.",
  },
  {
    _id: 336,
    day: "Dec 02",
    author: "Rosa Parks",
    quote:
      "I have learned over the years that when one's mind is made up, this diminishes fear.",
  },
  {
    _id: 337,
    day: "Dec 03",
    author: "Audrey Hepburn",
    quote: "Nothing is impossible, the word itself says, ‘I'm possible!'",
  },
  {
    _id: 338,
    day: "Dec 04",
    author: "Gloria Steinem",
    quote: "Dreaming, after all, is a form of planning.",
  },
  {
    _id: 339,
    day: "Dec 05",
    author: "Mark Twain",
    quote:
      "Twenty years from now you will be more disappointed by the things that you didn't do than by the ones you did do.",
  },
  {
    _id: 340,
    day: "Dec 06",
    author: "Tony Robbins",
    quote: "The only impossible journey is the one you never begin.",
  },
  {
    _id: 341,
    day: "Dec 07",
    author: "Michael Jordan",
    quote:
      "I've missed more than 9000 shots in my career. I've lost almost 300 games. 26 times I've been trusted to take the game winning shot and missed. I've failed over and over and over again in my life. And that is why I succeed.",
  },
  {
    _id: 342,
    day: "Dec 08",
    author: "Theodore Roosevelt",
    quote: "Do what you can, with what you have, where you are.",
  },
  {
    _id: 343,
    day: "Dec 09",
    author: "Albert Einstein",
    quote:
      "Imagination is everything. It is the preview of life’s coming attractions.",
  },
  {
    _id: 344,
    day: "Dec 10",
    author: "Muhammad Ali",
    quote: "Service to others is the rent you pay for your room here on earth.",
  },
  {
    _id: 345,
    day: "Dec 11",
    author: "Herbert Bayard Swope",
    quote:
      "I can’t give you a sure-fire formula for success, but I can give you a formula for failure: try to please everybody all the time.",
  },
  {
    _id: 346,
    day: "Dec 12",
    author: "J. K Rowling",
    quote:
      "It is our choices, that show what we truly are, far more than our abilities.",
  },
  {
    _id: 347,
    day: "Dec 13",
    author: "Ernest Hemingway",
    quote: "In order to write about life first you must live it.",
  },
  {
    _id: 348,
    day: "Dec 14",
    author: "John Wooden",
    quote: "Do not let making a living prevent you from making a life.",
  },
  {
    _id: 349,
    day: "Dec 15",
    author: "Anthony Bourdain",
    quote:
      "Context and memory play powerful roles in all the truly great meals in one's life.",
  },
  {
    _id: 350,
    day: "Dec 16",
    author: "Harriet Tubman",
    quote:
      "I grew up like a neglected weed - ignorant of liberty, having no experience of it.",
  },
  {
    _id: 351,
    day: "Dec 17",
    author: "Albert Einstein",
    quote: "Any fool can know. The point is to understand.",
  },
  {
    _id: 352,
    day: "Dec 18",
    author: "Anthony Bourdain",
    quote: "Luck is not a business model.",
  },
  {
    _id: 353,
    day: "Dec 19",
    author: "Lucy Maud Montgomery",
    quote:
      "Maybe that's enlightenment enough: to know that there is no final resting place of the mind, no moment of smug clarity. Perhaps wisdom ... is realizing how small I am, and unwise, and how far I have yet to go",
  },
  {
    _id: 354,
    day: "Dec 20",
    author: "William Butler Yates",
    quote:
      "People who lean on logic and philosophy and rational exposition end by starving the best part of the mind.",
  },
  {
    _id: 355,
    day: "Dec 21",
    author: "Lucy Maud Montgomery",
    quote:
      "Even when I'm alone I have real good company — dreams and imaginations and pretendings. I like to be alone now and then, just to think over things and taste them.",
  },
  {
    _id: 356,
    day: "Dec 22",
    author: "Albert Einstein",
    quote: "The only thing that interferes with my learning is my education.",
  },
  {
    _id: 357,
    day: "Dec 23",
    author: "Fred Rogers",
    quote:
      "All of us, at some time or other, need help. Whether we're giving or receiving help, each one of us has something valuable to bring to this world. That's one of the things that connects us as neighbors--in our own way, each one of us is a giver and a receiver.",
  },
  {
    _id: 358,
    day: "Dec 24",
    author: "Lucy Maud Montgomery",
    quote:
      "Don't you just love poetry that gives you a crinkly feeling up and down your back",
  },
  {
    _id: 359,
    day: "Dec 25",
    author: "Albert Einstein",
    quote:
      "The world as we have created it is a process of our thinking. It cannot be changed without changing our thinkin",
  },
  {
    _id: 360,
    day: "Dec 26",
    author: "Rumi",
    quote:
      "Yesterday I was clever, so I wanted to change the world. Today I am wise, so I am changing myself.",
  },
  {
    _id: 361,
    day: "Dec 27",
    author: "Walt Whitman",
    quote:
      "Do I contradict myself? Very well, then, I contradict myself; I am large -- I contain multitudes.",
  },
  {
    _id: 362,
    day: "Dec 28",
    author: "Neil Gaiman",
    quote:
      "Do I contradict myself? Very well, then, I contradict myself; I am large -- I contain multitudes",
  },
  {
    _id: 363,
    day: "Dec 29",
    author: "William Butler Yates",
    quote:
      "This melancholy London - I sometimes imagine that the souls of the lost are compelled to walk through its streets perpetually. One feels them passing like a whiff of air",
  },
  {
    _id: 364,
    day: "Dec 30",
    author: "Lucy Maud Montgomery",
    quote:
      "I don't know that she is as amusing as she was when she was a child, but she makes me love her and I like people who make me love them. It saves me so much trouble in making myself love them.",
  },
  {
    _id: 365,
    day: "Dec 31",
    author: "Aristotle",
    quote:
      "It is during our darkest moments that we must focus to see the light.",
  },
];
